import { handleActions } from 'redux-actions'

const defaultView = {
  fullscreen: false
}

export default handleActions({
  SET_FULLSCREEN_ON(state) {
    return Object.assign({}, state, { fullscreen: true })
  },

  SET_FULLSCREEN_OFF(state) {
    return Object.assign({}, state, { fullscreen: false })
  },
}, defaultView)




